import React from 'react';
import { Container as MUIContainer, ContainerProps as MUIContainerProps, styled } from '@mui/material';

export interface ContainerProps extends MUIContainerProps {
  /** Container content */
  children: React.ReactNode;
  /** Container width */
  maxWidth?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | false;
  /** Disable padding */
  disableGutters?: boolean;
}

const StyledContainer = styled(MUIContainer)(({ theme }) => ({
  paddingTop: theme.spacing(3),
  paddingBottom: theme.spacing(3),
  [theme.breakpoints.up('md')]: {
    paddingTop: theme.spacing(4),
    paddingBottom: theme.spacing(4),
  },
}));

export const Container: React.FC<ContainerProps> = ({
  children,
  maxWidth = 'lg',
  disableGutters = false,
  ...rest
}) => {
  return (
    <StyledContainer 
      maxWidth={maxWidth} 
      disableGutters={disableGutters}
      {...rest}
    >
      {children}
    </StyledContainer>
  );
};

export default Container;
